import { render, staticRenderFns } from "./ScoreAnalysis.vue?vue&type=template&id=77d80d32&scoped=true"
import script from "./ScoreAnalysis.vue?vue&type=script&lang=js"
export * from "./ScoreAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ScoreAnalysis.vue?vue&type=style&index=0&id=77d80d32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d80d32",
  null
  
)

export default component.exports